import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "error-msg-wrap" }
const _hoisted_2 = { class: "form-wrapper slide-up" }
const _hoisted_3 = { class: "form-close" }
const _hoisted_4 = { class: "meeting-form-visibility" }
const _hoisted_5 = { class: "meeting-form-row" }
const _hoisted_6 = { class: "meeting-form-row" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "meeting-section-top" }
const _hoisted_10 = { class: "meeting-section-num" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "meeting-section-bottom" }
const _hoisted_13 = { class: "meeting-section-time" }
const _hoisted_14 = { class: "meeting-section-time-input" }
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = { class: "meeting-section-desc" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = { class: "meeting-section-shows" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = {
  key: 0,
  class: "meeting-form-total"
}
const _hoisted_25 = { class: "meeting-form-label" }
const _hoisted_26 = {
  key: 0,
  class: "meeting-form-hint"
}
const _hoisted_27 = { style: {"margin-bottom":"10px","max-height":"200px","overflow":"auto"} }
const _hoisted_28 = {
  key: 0,
  style: {"margin-bottom":"10px"}
}
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "form-close-x",
          title: "Close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isPersonal)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[9] || (_cache[9] = _createElementVNode("b", null, "Only you and the attendees you pick", -1)),
              _cache[10] || (_cache[10] = _createTextVNode(" can see this meeting, its board and its history. Adding someone as an attendee is what gives them access. ", -1))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("b", null, "Everyone on the " + _toDisplayString(_ctx.team) + " team", 1),
              _cache[11] || (_cache[11] = _createTextVNode(" can see this meeting, its board and its history. Outside the team, only Team Hub admins can. Attendees are who you expect to be there; picking them doesn't change who can see it. ", -1))
            ], 64))
      ]),
      _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "meeting-form-label" }, "Meeting name", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.Name) = $event)),
        placeholder: "Meeting Name"
      }, null, 512), [
        [_vModelText, _ctx.formData.Name]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "meeting-form-label" }, "Date", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.Date) = $event))
          }, null, 512), [
            [_vModelText, _ctx.formData.Date]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "meeting-form-label" }, "Repeats", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.RecurrenceType) = $event))
          }, [...(_cache[13] || (_cache[13] = [
            _createStaticVNode("<option value=\"once\" data-v-2472077c>One time</option><option value=\"daily\" data-v-2472077c>Daily</option><option value=\"weekly\" data-v-2472077c>Weekly</option><option value=\"biweekly\" data-v-2472077c>Biweekly (every 2 weeks)</option><option value=\"monthly\" data-v-2472077c>Monthly</option>", 5)
          ]))], 512), [
            [_vModelSelect, _ctx.formData.RecurrenceType]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "meeting-form-label" }, "Start time", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.StartTime) = $event))
          }, [
            _cache[15] || (_cache[15] = _createElementVNode("option", {
              value: "",
              disabled: ""
            }, "Choose a time", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.startTimes, (t) => {
              return (_openBlock(), _createElementBlock("option", {
                key: t.value,
                value: t.value
              }, _toDisplayString(t.label), 9, _hoisted_7))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.formData.StartTime]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "meeting-form-label" }, "Time zone", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.TimeZone) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeZones, (z) => {
              return (_openBlock(), _createElementBlock("option", {
                key: z,
                value: z
              }, _toDisplayString(z.replace(/_/g, ' ')), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.formData.TimeZone]
          ])
        ])
      ]),
      _cache[26] || (_cache[26] = _createElementVNode("h3", {
        class: "meeting-form-label",
        style: {"margin-top":"0"}
      }, [
        _createTextVNode("Sections "),
        _createElementVNode("span", { class: "meeting-form-hint" }, "(set a time limit for each)")
      ], -1)),
      _createVNode(_component_draggable, {
        modelValue: _ctx.formData.Sections,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.Sections) = $event)),
        handle: ".meeting-section-handle"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.Sections, (section, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "meeting-section-row",
              key: i
            }, [
              _createElementVNode("div", _hoisted_9, [
                _cache[18] || (_cache[18] = _createElementVNode("span", {
                  class: "meeting-section-handle",
                  title: "Drag to reorder"
                }, "⋮⋮", -1)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(i + 1), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": ($event: any) => ((section.name) = $event),
                  placeholder: "Section name"
                }, null, 8, _hoisted_11), [
                  [_vModelText, section.name]
                ]),
                _createVNode(_component_svg_icon, {
                  icon: "x",
                  class: "meeting-section-remove",
                  onClick: ($event: any) => (_ctx.removeSection(i))
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "meeting-form-sublabel" }, "Time Limit", -1)),
                  _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "0",
                      "onUpdate:modelValue": ($event: any) => ((section.minutes) = $event)
                    }, null, 8, _hoisted_15), [
                      [
                        _vModelText,
                        section.minutes,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("span", null, "min", -1))
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "meeting-form-sublabel" }, "Description", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((section.description) = $event),
                    placeholder: "Description"
                  }, null, 8, _hoisted_17), [
                    [_vModelText, section.description]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (!_ctx.isPersonal)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((section.showScorecard) = $event)
                      }, null, 8, _hoisted_20), [
                        [_vModelCheckbox, section.showScorecard]
                      ]),
                      _createTextVNode("Show the " + _toDisplayString(_ctx.team) + " scorecard", 1)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isPersonal)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_21, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((section.showRocks) = $event)
                      }, null, 8, _hoisted_22), [
                        [_vModelCheckbox, section.showRocks]
                      ]),
                      _createTextVNode("Show the " + _toDisplayString(_ctx.team) + " rocks", 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("label", null, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": ($event: any) => ((section.hideBoard) = $event)
                  }, null, 8, _hoisted_23), [
                    [_vModelCheckbox, section.hideBoard]
                  ]),
                  _cache[22] || (_cache[22] = _createTextVNode("Hide the board", -1))
                ])
              ])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", {
        class: "meeting-form-addlink",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addSection()))
      }, "+ Add Section"),
      (_ctx.sectionsTotal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _cache[23] || (_cache[23] = _createTextVNode("Meeting length: ", -1)),
            _createElementVNode("b", null, _toDisplayString(_ctx.durationLabel(_ctx.sectionsTotal)), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("h3", _hoisted_25, [
          _cache[24] || (_cache[24] = _createTextVNode("Attendees", -1)),
          (!_ctx.isPersonal)
            ? (_openBlock(), _createElementBlock("span", _hoisted_26, " (optional)"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_27, [
          (!_ctx.employees.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, "No employees to select."))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (emp, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "checkbox-input"
            }, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": ($event: any) => ((emp.selected) = $event)
              }, null, 8, _hoisted_29), [
                [_vModelCheckbox, emp.selected]
              ]),
              _createElementVNode("div", null, _toDisplayString(emp.Name), 1)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("input", {
        class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
        type: "submit",
        value: _ctx.isEditing ? 'Save Meeting' : 'Create Meeting',
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submit()))
      }, null, 10, _hoisted_30)
    ])
  ]))
}